import React from "react"
import { FormGroup, Label, Input, Feedback } from "client/components"
import { After } from "./styled"

interface FormatInputProps {
    title: string
    value: string
    after?: string
    validation?: string
    readOnly?: boolean
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    onBlur?: React.FocusEventHandler<HTMLInputElement>
}
const FormatInput = ({
    title,
    value,
    after = null,
    validation,
    readOnly = false,
    onChange,
    onBlur,
}: FormatInputProps) => (
    <FormGroup>
        <Label>
            {title}
            {after && <After>{`, ${after}`}</After>}
        </Label>
        <Input
            type="text"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
        />
        <Feedback>{validation && validation}</Feedback>
    </FormGroup>
)

export default FormatInput
